import type { ToolResult } from "./tools";

export const READINESS_TOOL_NAME = "getSourcingEventReadiness";

type FieldStatus = {
  fieldKey: string;
  gate: string;
  satisfied: boolean;
  error?: { code: string; params?: Record<string, string> } | null;
};

type MissingField = { fieldKey: string; error?: string; params?: Record<string, string> };

export const readinessForModel = (result: ToolResult): ToolResult => {
  if (!result.ok) return result;
  const fields = (result.data as { fields?: FieldStatus[] } | null)?.fields;
  if (!Array.isArray(fields)) return result;
  const missingByGate: Record<string, MissingField[]> = {};
  for (const field of fields) {
    if (field.satisfied) continue;
    const missing: MissingField = { fieldKey: field.fieldKey };
    if (field.error?.code) missing.error = field.error.code;
    if (field.error?.params && Object.keys(field.error.params).length > 0) missing.params = field.error.params;
    (missingByGate[field.gate] ??= []).push(missing);
  }
  return {
    ok: true,
    data: {
      checkedFields: fields.length,
      missingCount: Object.values(missingByGate).reduce((sum, missing) => sum + missing.length, 0),
      missingByGate,
    },
  };
};
